import { useEffect } from "react";

// Bidirectional scroll reveal — animates in AND out as user scrolls up/down
export function useScrollReveal() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) {
      document.querySelectorAll(".fade-in, .reveal-left, .reveal-right, .reveal-scale, .reveal-up")
        .forEach((el) => el.classList.add("visible"));
      return;
    }

    const selectors = ".fade-in, .reveal-left, .reveal-right, .reveal-scale, .reveal-up";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            entry.target.classList.remove("hidden");
          } else {
            // Re-animate when scrolling back up
            entry.target.classList.remove("visible");
            entry.target.classList.add("hidden");
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -30px 0px" }
    );

    const elements = document.querySelectorAll(selectors);
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  });
}
